import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AllGarageReviewsLayer from "../../components/garage-reviews/AllGarageReviewsLayer";

const AllGarageReviewPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb routePath="/garage-reviews" routeName="Home" title="Review Moderation" />
        <AllGarageReviewsLayer/>
      </MasterLayout>
    </>
  );
};

export default AllGarageReviewPage;
